import {createStore, applyMiddleware, compose} from 'redux';
import { routerMiddleware } from 'connected-react-router';
import rootReducer from '../reducers';
import rootSaga from "../saga";
import createSagaMiddleware from 'redux-saga';


export default function reduxConfig(initialState,history){

  const sagaMiddleware = createSagaMiddleware();
  
  const enhancer = compose(applyMiddleware(routerMiddleware(history),sagaMiddleware))

  let store = createStore(rootReducer(history),initialState,enhancer);
  sagaMiddleware.run(rootSaga);
  return store
}

